export const MIN_PASSWORD_CHARACTERS = 15;
export const MAX_PASSWORD_CHARACTERS = 128;


export function normalizedPasswordLength(password) {
  if (typeof password !== 'string') return 0;
  return Array.from(password.normalize('NFC')).length;
}


export function passwordPolicyError(password) {
  if (typeof password !== 'string' || !password) return 'Password is required.';
  if (password !== password.trim()) return 'Password cannot begin or end with a space.';

  const length = normalizedPasswordLength(password);
  if (length < MIN_PASSWORD_CHARACTERS) {
    return `Password must be at least ${MIN_PASSWORD_CHARACTERS} characters.`;
  }
  if (length > MAX_PASSWORD_CHARACTERS) {
    return `Password must be no more than ${MAX_PASSWORD_CHARACTERS} characters.`;
  }
  return '';
}
